import type { ClinicalDocumentType } from '@/entities/clinicalDocument/types'
import { parseDateOrNull, toLocalDateKey } from '@/shared/lib/date'

const DOCUMENT_DATE_YMD = /^\d{4}-\d{2}-\d{2}$/

/** Data de calendário YYYY-MM-DD; inválida ou vazia cai para hoje (fuso local). */
export const normalizeDocumentDate = (
  value: string | null | undefined,
  now: Date = new Date(),
): string => {
  const ymd = (value ?? '').trim().slice(0, 10)
  if (DOCUMENT_DATE_YMD.test(ymd) && parseDateOrNull(ymd)) return ymd
  return toLocalDateKey(now)
}

/**
 * Data impressa no documento: `documentDate` gravada, senão o dia local de `createdAt`.
 */
export const documentDateFromRecord = (
  record: { documentDate?: string | null; createdAt: string },
  now: Date = new Date(),
): string => {
  const explicit = record.documentDate?.trim().slice(0, 10)
  if (explicit && DOCUMENT_DATE_YMD.test(explicit) && parseDateOrNull(explicit)) return explicit
  const parsed = parseDateOrNull(record.createdAt)
  return parsed ? toLocalDateKey(parsed) : toLocalDateKey(now)
}

/** Normaliza tipo vindo da UI, API ou chat IA (inclui sinónimos em PT e maiúsculas). */
export const normalizeClinicalDocumentType = (value: unknown): ClinicalDocumentType => {
  if (typeof value !== 'string') return 'prescription'
  const s = value
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .replace(/_/g, '')
  if (s === 'certificate' || s === 'atestado' || s === 'atestados') return 'certificate'
  if (s === 'request' || s === 'solicitacao' || s === 'pedidoexame' || s === 'solicitacaoexame') return 'request'
  if (s === 'generic' || s === 'generico') return 'generic'
  if (s === 'prescription' || s === 'receita' || s === 'prescricao') return 'prescription'
  return 'prescription'
}
